<template>
  <b-nav-item-dropdown no-caret>
    <template slot="button-content">
      <span class="btn-text">Comercial</span>
    </template>
    <b-dropdown-item
      v-for="module in filteredUserModules"
      :key="module.id"
      :disabled="!module.is_active"
      @click="$router.push({name: module.component_name})"
    >
      {{ module.description }}
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>
<script>
import dropdownCommercialCompositions from './compositions/DropdownCommercial'

export default {
  name: 'HeaderDropdownCommercial',
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  setup (props, context) {
    const { filteredUserModules } = dropdownCommercialCompositions(props, context)
    return {
      filteredUserModules
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/nav_bar/HeaderDropdownCommercial.vue